module.exports = __webpack_public_path__ + "static/media/reportCxcInvoices.fe1c8933.svg";